// eslint-disable-next-line import/no-anonymous-default-export
export default { CARD: 'card', BOX: 'box' };
